import { render } from "./OtpVerificationModal.vue?vue&type=template&id=38290dbe&scoped=true"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"

import "./OtpVerificationModal.vue?vue&type=style&index=0&id=38290dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38290dbe"]])

export default __exports__